var _rect, _rect2, _rect3, _rect4, _rect5, _line, _rect6, _rect7, _rect8, _line2, _rect9, _rect10, _rect11, _line3, _rect12, _rect13, _rect14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDesktopMultimediaPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 1200,
  viewBox: "0 0 300 1200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 1.2832,
  width: 299,
  height: 1198,
  rx: 7.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20.7832,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 63.7832,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 91.7832,
  width: 260,
  height: 63,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 166.783,
  width: 260,
  height: 146,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 333.283,
  x2: 20,
  y2: 333.283,
  stroke: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 352.783,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 380.783,
  width: 260,
  height: 63,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 455.783,
  width: 260,
  height: 146,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 622.283,
  x2: 20,
  y2: 622.283,
  stroke: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 641.783,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 669.783,
  width: 260,
  height: 63,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 744.783,
  width: 260,
  height: 146,
  fill: "#E5E5E5"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 911.283,
  x2: 20,
  y2: 911.283,
  stroke: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 930.783,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 958.783,
  width: 260,
  height: 63,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 1033.78,
  width: 260,
  height: 146,
  fill: "#E5E5E5"
})));
export default SvgDesktopMultimediaPlaceholder;